import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AdminAPI from "../../services/adminApi";
import AdminSidebar from "../components/AdminSidebar";
import AdminNavbar from "../components/AdminNavbar";

function FarmerDetails() {
  const { id } = useParams();

  const [data, setData] = useState({
    profile: null,
    location: null,
    dashboard: null,
    weather: null,
    recommendations: [],
    checklists: []
  });

  useEffect(() => {
    fetchFarmerDetails();
  }, []);

  const fetchFarmerDetails = async () => {
    try {
      const res = await AdminAPI.get(`/farmer-details/${id}`);
      setData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="d-flex">
      <AdminSidebar />

      <div
        style={{
          flex: 1,
          background: "#f5f7fa",
          minHeight: "100vh",
          padding: "20px"
        }}
      >
        <AdminNavbar />

        {/* Profile */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <h3>👨‍🌾 Farmer Profile</h3>

            <div className="row mt-3">
              <div className="col-md-4">
                <p><strong>Name:</strong> {data.profile?.full_name}</p>
                <p><strong>Email:</strong> {data.profile?.email}</p>
                <p><strong>Mobile:</strong> {data.profile?.mobile}</p>
              </div>

              <div className="col-md-4">
                <p><strong>State:</strong> {data.profile?.state}</p>
                <p><strong>District:</strong> {data.profile?.district}</p>
                <p><strong>Village:</strong> {data.profile?.village}</p>
              </div>

              <div className="col-md-4">
                <p><strong>Land Size:</strong> {data.profile?.land_size}</p>
                <p><strong>Primary Crop:</strong> {data.profile?.primary_crop}</p>
                <p>
                  <strong>Status:</strong>{" "}
                  <span className="badge bg-success">
                    {data.profile?.status}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Location */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <h3>📍 Location Details</h3>

            {data.location ? (
              <div className="row mt-3">
                <div className="col-md-4">
                  <p><strong>Latitude:</strong> {data.location.latitude}</p>
                </div>

                <div className="col-md-4">
                  <p><strong>Longitude:</strong> {data.location.longitude}</p>
                </div>

                <div className="col-md-4">
                  <p><strong>Address:</strong> {data.location.address}</p>
                </div>
              </div>
            ) : (
              <p>No location data available</p>
            )}
          </div>
        </div>

        {/* Dashboard Stats */}
        <div className="row mt-4 g-4">
          <div className="col-md-3">
            <div className="card shadow border-0 p-4">
              <h6>Current Day</h6>
              <h2>
                {data.dashboard?.current_day || 0}/
                {data.dashboard?.total_days || 60}
              </h2>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card shadow border-0 p-4">
              <h6>Current Phase</h6>
              <h5>{data.dashboard?.current_phase || "Not Started"}</h5>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card shadow border-0 p-4">
              <h6>Health Score</h6>
              <h2>{data.dashboard?.health_score || 0}%</h2>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card shadow border-0 p-4">
              <h6>Consistency</h6>
              <h2>{data.dashboard?.consistency_rate || 0}%</h2>
            </div>
          </div>
        </div>

        {/* Weather */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <h3>🌦️ Latest Weather</h3>

            {data.weather ? (
              <div className="row mt-3">
                <div className="col-md-2">
                  <p><strong>Temp:</strong> {data.weather.temperature}°C</p>
                </div>

                <div className="col-md-2">
                  <p><strong>Humidity:</strong> {data.weather.humidity}%</p>
                </div>

                <div className="col-md-2">
                  <p><strong>Rain:</strong> {data.weather.rainfall}</p>
                </div>

                <div className="col-md-2">
                  <p><strong>Wind:</strong> {data.weather.wind_speed}</p>
                </div>

                <div className="col-md-4">
                  <p>
                    <strong>Condition:</strong>{" "}
                    {data.weather.weather_condition}
                  </p>
                </div>
              </div>
            ) : (
              <p>No weather data</p>
            )}
          </div>
        </div>

        {/* AI Recommendations */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <h3>🤖 AI Recommendations</h3>

            <ul className="list-group mt-3">
              {data.recommendations.map((item) => (
                <li
                  key={item.id}
                  className="list-group-item"
                >
                  <strong>{item.recommendation_type}:</strong>{" "}
                  {item.recommendation_text}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Checklist History */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <h3>✅ Checklist History</h3>

            <table className="table mt-3">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Temp</th>
                  <th>Moisture</th>
                  <th>Humidity</th>
                  <th>pH</th>
                  <th>Notes</th>
                </tr>
              </thead>

              <tbody>
                {data.checklists.map((item) => (
                  <tr key={item.id}>
                    <td>{item.checklist_date}</td>
                    <td>{item.temperature}</td>
                    <td>{item.moisture_level}</td>
                    <td>{item.humidity}</td>
                    <td>{item.ph_level}</td>
                    <td>{item.notes}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
}

export default FarmerDetails;